module.exports = __webpack_public_path__ + "img/background.a2a28e83.png";